/** Explicit catalogue compatibility only; never infer fitment from product text. */
export function canonicalShopModel(value:string):string {
 const name=value.trim().replace(/\s+/g,' ');
 const tesla=name.match(/^(?:Tesla\s+)?Model\s*([S3XY])(?=\s|$|[-·])/i);
 return tesla?'Tesla Model '+tesla[1].toUpperCase():name;
}
export function matchesVehicle(product:{compatibleVehicles?:string[]},model:string):boolean {
 if(!model)return true;
 const selected=canonicalShopModel(model).toLowerCase();
 return (product.compatibleVehicles||[]).some(value=>value==='any'||(selected!=='other-evs'&&canonicalShopModel(value).toLowerCase()===selected));
}
